export const PREDICTIVE_MODELS = {
  path: 'predictive_models',
  redirect: { name: 'predictive_models' },
  children: [
    {
      path: '',
      name: 'predictive_models',
      meta: {
        title: 'predictive_models.list.meta.title',
        permissions: ['predictive_model_r']
      },
      component: () => import('@/views/recruiter/predictive_models/PredictiveModelsTableView.vue')
    },
    /* AI */
    {
      path: 'AI/:uuid',
      name: 'view_predictive_model_ai',
      meta: {
        title: 'predictive_models.list.meta.title',
        permissions: ['predictive_model_ai_r']
      },
      component: () => import('@/views/recruiter/predictive_models/PredictiveModelsAIView.vue')
    },
    {
      path: 'AI/create',
      name: 'create_predictive_model_ai',
      meta: {
        title: 'predictive_models.list.meta.title',
        permissions: ['predictive_model_ai_w']
      },
      component: () => import('@/views/recruiter/predictive_models/PredictiveModelsAiCreateView.vue')
    },
    /* BENCHMARK */
    {
      // Using regex from vue router doc to check UUID param
      path: 'benchmark/:uuid([a-z0-9]{32})',
      name: 'view_benchmark',
      meta: {
        permissions: ['predictive_model_r']
      },
      beforeEnter: () => {
        // Go back to top after redirection from edit or duplicate
        window.scrollTo(0, 0);
      },
      component: () => import('@/views/recruiter/predictive_models/PredictiveModelBenchmarkView.vue')
    },
    /* CUSTOM */
    {
      // Using regex from vue router doc to check UUID param
      path: ':uuid([a-z0-9]{32})',
      name: 'view_predictive_model',
      meta: {
        permissions: ['predictive_model_r']
      },
      beforeEnter: () => {
        // Go back to top after redirection from edit or duplicate
        window.scrollTo(0, 0);
      },
      component: () => import('@/views/recruiter/predictive_models/PredictiveModelView.vue')
    },
    {
      // Using regex from vue router doc to check UUID param
      path: ':uuid([a-z0-9]{32})/edit',
      name: 'edit_predictive_model',
      meta: {
        permissions: ['predictive_model_r', 'predictive_model_w']
      },
      component: () => import('@/views/recruiter/predictive_models/create/PredictiveModelStepperView.vue')
    },
    {
      path: 'create',
      name: 'predictive_models_create_method',
      meta: {
        title: 'predictive_models.list.meta.title',
        permissions: ['predictive_model_r']
      },
      component: () => import('@/views/recruiter/predictive_models/create/PredictiveModelStepperView.vue')
    }
  ]
};
